/// <reference types="@types/googlemaps" />
import React, { useEffect, useState, useContext } from "react";
import { FloorOverlay } from "generated/graphql";
import { useHistory } from "react-router-dom";
import firebase from "../../Firebase/firebase";
import "firebase/firestore";
import { getGoogleMaps } from "config/GoogleMaps";
import { AuthContext } from "Firebase/AuthProvider";
import { BuildingContext } from "Context/BuildingProvider";
import { OnlineBuildingGuard, LastLocation } from "lib/realtimeDBTypes";
import InfoWindowEx from "Modules/LiveScreen/InfoWindowEx";
import ReactDOM from "react-dom";
import { useMutation } from "@apollo/client";
import { POST_USER_WAYPOINT } from "lib/tasks";
import { PostUserWaypointMutationVariables } from "generated/graphql";
import { MarkerObject } from "components/Maps/MarkerListMap";
import { StandardContainer } from "components/Layout/StandardStyledComponents";
import { Button } from "@material-ui/core";

interface LocationListenerObject {
  id: string;
  listener: firebase.database.Reference;
}

interface VanillaMapContainerProps {
  floorOverlays: Pick<
    FloorOverlay,
    | "BuildingId"
    | "CenterLat"
    | "CenterLng"
    | "D_diff"
    | "FloorNumber"
    | "Id"
    | "ImageUrl"
    | "Name"
    | "Rot"
    | "created_at"
    | "k_diff"
    | "updated_at"
  >[];
  onlineBuildingGuards: OnlineBuildingGuard[];
  onlineBuildingGuardIds: string[];
  handleMarkerClicked: (id: string) => void;
}
interface VanillaMapContainerState {
  currentFloorNumber: number;
  currentMarker: google.maps.Marker | null;
  firebaseLocationListenerObjects: LocationListenerObject[];
  map?: google.maps.Map;
}
const DEFAULT_STATE: VanillaMapContainerState = {
  currentFloorNumber: 0,
  currentMarker: null,
  firebaseLocationListenerObjects: [],
  map: undefined,
};
let map: google.maps.Map;

export default function VanillaMapContainer({
  floorOverlays,
  onlineBuildingGuards,
  onlineBuildingGuardIds,
  handleMarkerClicked,
}: VanillaMapContainerProps) {
  const { getImageUrl, getDatabase } = useContext(AuthContext);
  const { currentBuilding, buildingState } = useContext(BuildingContext);
  const history = useHistory();
  const [insertWaypoint, { data }] =
    useMutation<PostUserWaypointMutationVariables>(POST_USER_WAYPOINT);
  const [state, setState] = useState(DEFAULT_STATE);

  var overlay: google.maps.OverlayView;

  var loc_center: google.maps.LatLng;
  var CenterLat: number;
  var CenterLng: number;
  var k_diff: number = 0.005;
  var D_diff: number = 0.01;
  var rot: number = 0;
  let infowindow;
  let markerList: any[] = [];
  let currentFloorNumber = 0;
  class DebugOverlay extends google.maps.OverlayView {
    map_?: google.maps.Map;
    opacity?: number;
    private bounds: google.maps.LatLngBounds;
    private image: string;
    private div?: HTMLElement;
    constructor(bounds: google.maps.LatLngBounds, image: any) {
      super();
      this.bounds = bounds;
      this.image = image;
    }

    onAdd() {
      this.div = document.createElement("div");
      this.div.style.borderStyle = "none";
      this.div.style.borderWidth = "0px";
      this.div.style.position = "absolute";
      this.div.style.visibility = "visible";
      var img = document.createElement("img");
      img.src = this.image;
      img.style.width = "100%";
      img.style.height = "100%";
      img.style.opacity = "1";
      img.style.position = "absolute";
      img.style.transform = "rotate(" + rot + "rad)";
      this.div.appendChild(img);
      var panes = this.getPanes();
      panes.overlayLayer.appendChild(this.div);
    }

    draw() {
      var overlayProjection = this.getProjection();
      var sw = overlayProjection.fromLatLngToDivPixel(
        this.bounds!.getSouthWest()
      );
      var ne = overlayProjection.fromLatLngToDivPixel(
        this.bounds!.getNorthEast()
      );
      var div = this.div;
      div!.style.left = sw.x + "px";
      div!.style.top = ne.y + "px";
      div!.style.width = ne.x - sw.x + "px";
      div!.style.height = sw.y - ne.y + "px";
      div!.style.transform = "rotate(" + rot + "deg)";
    }

    onRemove() {
      this?.div?.parentNode?.removeChild(this.div);
      delete this.div;
    }
  }

  const setFloor = async () => {
    initMap("map");
  };

  const initMap = async (mapId: string) => {
    loc_center = new google.maps.LatLng(
      currentBuilding!.centerLat,
      currentBuilding!.centerLong
    );
    let url = "";
    if (!!getImageUrl) {
      url = await getImageUrl(
        "overlays",
        currentBuilding?.Id +
          "/" +
          floorOverlays[state.currentFloorNumber].Id +
          ".jpg"
      );
    }

    const mapElement = document.getElementById(mapId);
    var mapOptions = {
      zoom: 18,
      center: loc_center,
      backgroundColor: "#051932",
      disableDefaultUI: true,
    };

    let initialize = () => {
      const customStyled = [
        {
          featureType: "all",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ];
      map.set("styles", customStyled);

      var newPointA = new window.google.maps.LatLng(
        CenterLat - k_diff,
        CenterLng - D_diff
      );
      var newPointB = new window.google.maps.LatLng(
        CenterLat + k_diff,
        CenterLng + D_diff
      );
      var bounds = new window.google.maps.LatLngBounds(newPointA, newPointB);
      var srcImage = url; //"https://res.cloudinary.com/dx8nclins/image/upload/v1569765645/buildings/fb10989e-942e-4142-8687-e7e903b03cef.png";

      overlay = new DebugOverlay(bounds, srcImage);
      overlay.setMap(map);

      const floorChange = async (controlDiv: HTMLElement): Promise<any> => {
        var controlUI = document.createElement("div");
        controlUI.style.backgroundColor = "#fff";
        controlUI.style.marginRight = "5px";
        controlUI.style.border = "2px solid #fff";
        controlUI.style.borderRadius = "3px";
        controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
        controlUI.style.cursor = "pointer";
        controlUI.style.marginBottom = "22px";
        controlUI.style.textAlign = "center";
        controlDiv.appendChild(controlUI);

        var controlText = document.createElement("div");
        controlText.style.color = "rgb(25,25,25)";
        controlText.style.fontFamily = "Roboto,Arial,sans-serif";
        controlText.style.fontSize = "16px";
        controlText.style.lineHeight = "38px";
        controlText.style.paddingLeft = "5px";
        controlText.style.paddingRight = "5px";
        controlText.innerHTML = "Floor Up";
        controlUI.appendChild(controlText);

        var floorTextUI = document.createElement("div");
        floorTextUI.style.backgroundColor = "#fff";
        floorTextUI.style.marginRight = "5px";
        floorTextUI.style.border = "2px solid #fff";
        floorTextUI.style.borderRadius = "3px";
        floorTextUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
        floorTextUI.style.cursor = "pointer";
        floorTextUI.style.marginBottom = "22px";
        floorTextUI.style.textAlign = "center";
        controlDiv.appendChild(floorTextUI);

        var floorText = document.createElement("div");
        floorText.style.color = "rgb(25,25,25)";
        floorText.style.fontFamily = "Roboto,Arial,sans-serif";
        floorText.style.fontSize = "16px";
        floorText.style.lineHeight = "38px";
        floorText.style.paddingLeft = "5px";
        floorText.style.paddingRight = "5px";
        floorText.innerHTML = "Floor Number: " + currentFloorNumber;
        floorTextUI.appendChild(floorText);

        controlUI.addEventListener("click", async () => {
          if (currentFloorNumber === floorOverlays.length - 1) {
            console.log("highest floor");
          } else {
            overlay.setMap(null);
            const newCurrentFloor = floorOverlays[currentFloorNumber + 1];
            const newCurrentFloorNumber = currentFloorNumber + 1;
            currentFloorNumber = newCurrentFloorNumber;
            if (!!getImageUrl) {
              url = await getImageUrl(
                "overlays",
                currentBuilding?.Id + "/" + newCurrentFloor.Id + ".jpg"
              );
            }
            var srcImage = url;

            var newPointA = new window.google.maps.LatLng(
              CenterLat - newCurrentFloor.k_diff,
              CenterLng - newCurrentFloor.D_diff
            );

            var newPointB = new window.google.maps.LatLng(
              CenterLat + newCurrentFloor.k_diff,
              CenterLng + newCurrentFloor.D_diff
            );

            var bounds = new window.google.maps.LatLngBounds(
              newPointA,
              newPointB
            );
            rot = newCurrentFloor.Rot;
            overlay = new DebugOverlay(bounds, srcImage);
            overlay.setMap(map);
            /* eslint-disable */
            markerList.forEach((marker, index) => {
              let labelTextAdd = "";
              if (marker.floor !== newCurrentFloor.FloorNumber) {
                marker.setOpacity(0.3);
                const floorLabel = marker.floor ? marker.floor : "loading";
                labelTextAdd = " - " + floorLabel;
              } else {
                marker.setOpacity(1);
              }
              const labelText = marker.title + labelTextAdd;
              marker.setLabel({
                color: "black",
                fontWeight: "bold",
                text: labelText,
              });
            });
            setState({ ...state, currentFloorNumber: newCurrentFloorNumber });
            floorText.innerHTML = "Floor Number: " + currentFloorNumber;
          }
        });

        var controlUI2 = document.createElement("div");
        controlUI2.style.backgroundColor = "#fff";
        controlUI2.style.marginRight = "5px";
        controlUI2.style.border = "2px solid #fff";
        controlUI2.style.borderRadius = "3px";
        controlUI2.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
        controlUI2.style.cursor = "pointer";
        controlUI2.style.marginBottom = "22px";
        controlUI2.style.textAlign = "center";
        controlDiv.appendChild(controlUI2);

        var controlText2 = document.createElement("div");
        controlText2.style.color = "rgb(25,25,25)";
        controlText2.style.fontFamily = "Roboto,Arial,sans-serif";
        controlText2.style.fontSize = "16px";
        controlText2.style.lineHeight = "38px";
        controlText2.style.paddingLeft = "5px";
        controlText2.style.paddingRight = "5px";
        controlText2.innerHTML = "Floor Down";
        controlUI2.appendChild(controlText2);

        controlUI2.addEventListener("click", async () => {
          console.log("floor down");
          if (currentFloorNumber === 0) {
            console.log("lowest");
          } else {
            overlay.setMap(null);
            const newCurrentFloor = floorOverlays[currentFloorNumber - 1];
            const newCurrentFloorNumber = currentFloorNumber - 1;
            currentFloorNumber = newCurrentFloorNumber;
            if (!!getImageUrl) {
              url = await getImageUrl(
                "overlays",
                currentBuilding?.Id + "/" + newCurrentFloor?.Id + ".jpg"
              );
            }
            var srcImage = url;

            var newPointA = new window.google.maps.LatLng(
              CenterLat - newCurrentFloor.k_diff,
              CenterLng - newCurrentFloor.D_diff
            );

            var newPointB = new window.google.maps.LatLng(
              CenterLat + newCurrentFloor.k_diff,
              CenterLng + newCurrentFloor.D_diff
            );

            var bounds = new window.google.maps.LatLngBounds(
              newPointA,
              newPointB
            );
            rot = newCurrentFloor.Rot;
            overlay = new DebugOverlay(bounds, srcImage);
            overlay.setMap(map);
            /* eslint-disable */
            markerList.forEach((marker, index) => {
              let labelTextAdd = "";

              if (marker.floor !== newCurrentFloor.FloorNumber) {
                marker.setOpacity(0.3);
                const floorLabel = marker.floor ? marker.floor : "loading";
                labelTextAdd = " - " + floorLabel;
              } else {
                marker.setOpacity(1);
              }
              const labelText = marker.title + labelTextAdd;
              marker.setLabel({
                color: "black",
                fontWeight: "bold",
                text: labelText,
              });
            });
            setState({ ...state, currentFloorNumber: newCurrentFloorNumber });
            floorText.innerHTML = "Floor Number: " + currentFloorNumber;
          }
        });
      };

      var floorControlDiv = document.createElement("div");
      floorChange(floorControlDiv);

      map.controls[window.google.maps.ControlPosition.RIGHT_CENTER].push(
        floorControlDiv
      );

      startListeningToFirebase();
      if (!!getDatabase) {
        //initFirebase(getDatabase());
      } else {
        console.log("no database");
      }
      setState({ ...state, map: map });
    };

    if (!!mapElement) {
      map = new google.maps.Map(mapElement, mapOptions);
      initialize();
    }
    window.google.maps.event.addListener(map, "rightclick", (event) => {
      const position = event.latLng;

      if (state.currentMarker !== null) {
        infowindow = new window.google.maps.InfoWindow({
          content: '<div id="infoWindow" />',
          position: position,
        });

        infowindow.addListener("domready", (e: any) => {
          ReactDOM.render(
            <InfoWindowEx
              sendToWaypoint={sendUserWaypoint}
              event={event}
              //@ts-ignore
              name={state?.currentMarker?.title}
            />,
            document.getElementById("infoWindow")
          );
        });

        infowindow.open(map);
      }
    });
  };

  const sendUserWaypoint = async (
    event: google.maps.MapMouseEvent,
    title: string
  ) => {
    let selectedGuard: OnlineBuildingGuard;
    onlineBuildingGuardIds.forEach((id: string) => {
      //@ts-ignore
      let guard: OnlineBuildingGuard = onlineBuildingGuards[id];
      if (guard.name === title) {
        selectedGuard = guard;
      }
    });

    await insertWaypoint({
      variables: {
        BuildingId: currentBuilding!.Id,
        Lat: event.latLng.lat(),
        Lng: event.latLng.lng(),
      },
    });

    // hasuraClient
    //   .mutate({
    //     mutation: POST_WAYPOINT,
    //     variables: {
    //       BuildingId: this.props.currentBuilding.Id,
    //       Lat: event.latLng.lat(),
    //       Lng: event.latLng.lng(),
    //     },
    //   })
    //   .then((resp) => {
    //     this.sendTaskToUser(
    //       resp.data.insert_Task.returning[0].Id,
    //       selectedGuard.buildingGuardId
    //     );
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };

  useEffect(() => {
    let googleMapPromise = getGoogleMaps();
    CenterLat = currentBuilding?.centerLat;
    CenterLng = currentBuilding?.centerLong;
    k_diff = floorOverlays[state.currentFloorNumber]?.k_diff;
    D_diff = floorOverlays[state.currentFloorNumber]?.D_diff;
    rot = floorOverlays[state.currentFloorNumber]?.Rot;
    if (!window.google) {
      Promise.all([googleMapPromise]).then((values) => {
        let google = values[0];

        initMap("map");
      });
    } else {
      initMap("map");
    }
  }, []);

  const startListeningToFirebase = () => {
    if (!!getDatabase) {
      const database = getDatabase();
      let locationListener = database.ref(
        "buildings/" + currentBuilding!.Id + "/lastLocations/"
      );

      locationListener.on("value", (snapshot) => {
        const value = snapshot.val();
        for (const key in value) {
          //console.log("🚀 ~ file: VanillaMapContainer.tsx ~ line 452 ~ locationListener.on ~ key", key)
          if (buildingState?.onlineBuildingGuards) {
            const user = buildingState?.onlineBuildingGuards[parseInt(key)];

            //console.log("🚀 ~ file: VanillaMapContainer.tsx ~ line 455 ~ locationListener.on ~ user", user)
            //console.log("🚀 ~ file: VanillaMapContainer.tsx ~ line 459 ~ locationListener.on ~ onlineBuildingGuards", buildingState)
            const location = value[key];
            //console.log("🚀 ~ file: VanillaMapContainer.tsx ~ line 457 ~ locationListener.on ~ location", location)
            if (user) {
              checkIfUserHasMarker(user.name, location, key);
            }
          }
        }
      });
    }
  };

  // useEffect(() => {
  //   const locationListenerObjects = state.firebaseLocationListenerObjects;
  //   if (getDatabase) {
  //     const database = getDatabase();
  //     for (const key in onlineBuildingGuards) {
  //       const id = onlineBuildingGuards[key].buildingGuardId;
  //       let listenersHaveId = false;
  //       for (let j = 0; j < state.firebaseLocationListenerObjects.length; j++) {
  //         if (state.firebaseLocationListenerObjects[j].id === id) {
  //           listenersHaveId = true;
  //         }
  //       }
  //       if (!listenersHaveId) {
  //         const onlineBuildingGuard = onlineBuildingGuards[key];
  //         let locationListener = database.ref(
  //           "buildings/" + currentBuilding!.Id + "/lastLocations/" + id
  //         );
  //         locationListener.on("value", (snapshot) => {
  //           const location = snapshot.val();
  //           if (location !== null) {
  //             checkIfUserHasMarker(
  //               onlineBuildingGuard.name,
  //               location,
  //               onlineBuildingGuard.buildingGuardId
  //             );
  //           } else {
  //             //user changed roles or logged out
  //           }
  //         });
  //         const locationListenerObject = {
  //           id: id,
  //           listener: locationListener,
  //         };
  //         locationListenerObjects.push(locationListenerObject);
  //       }
  //     }
  //     setState({
  //       ...state,
  //       firebaseLocationListenerObjects: locationListenerObjects,
  //     });
  //   }
  // }, [onlineBuildingGuards]);

  const checkIfUserHasMarker = async (
    name: string,
    location: LastLocation,
    id: string
  ) => {
    if (!window.google) {
      let googleMapPromise = getGoogleMaps();
      await Promise.all([googleMapPromise]);
    }
    let marker: MarkerObject;
    let opacity = 1;
    let labelTextAdd = "";
    if (location.floor !== state.currentFloorNumber) {
      opacity = 0.3;
      const floorLabel = location.floor ? location.floor : "loading";
      labelTextAdd = " - " + floorLabel;
    }
    const labelText = name + labelTextAdd;
    if (typeof location === "object") {
      if (markerList.length === 0) {
        //@ts-ignore
        marker = new google.maps.Marker({
          position: location,
          title: name,
          //@ts-ignore
          //id: id,
          zIndex: 3,
          //@ts-ignore
          floor: location.floor,
          opacity: opacity,
          icon: "https://www.google.com/mapfiles/marker.png",
          label: {
            color: "black",
            fontWeight: "bold",
            text: labelText,
          },
          //map: state.map,
        });
        marker.id = id;
        marker.setMap(map);
        markerList.push(marker);
        let markerTitle = name;

        ((marker, markerTitle) => {
          //@ts-ignore
          google.maps.event.addListener(
            marker,
            "click",

            // this.markerClicked(marker)

            () => {
              markerList.forEach((marker1) => {
                // let label = marker1.getLabel();
                //label.color = 'black';
                //marker1.setLabel(label);
                marker1.setIcon("https://www.google.com/mapfiles/marker.png");
              });
              //@ts-ignore
              marker.setIcon(
                "https://www.google.com/mapfiles/marker_green.png"
              );
              markerClicked(marker);
            }
          );
        })(marker, markerTitle);
      } else {
        for (var i = 0; i < markerList.length; i++) {
          if (!markerList[i].map) {
            markerList[i].setMap(map);
          }
          if (markerList[i].getTitle() === name) {
            // eslint-disable-next-line
            if (location.lat === 0.0 || location.lat == undefined) {
              markerList[i].setMap(null);
              return;
            } else {
              markerList[i].setPosition(location);
              markerList[i].setOpacity(opacity);
              markerList[i].setLabel({
                color: "black",
                fontWeight: "bold",
                text: labelText,
              });
              return;
            }
          }
        }

        marker = new google.maps.Marker({
          position: location,
          title: name,
          opacity: opacity,
          label: {
            color: "black",
            fontWeight: "bold",
            text: labelText,
          },
          icon: "https://www.google.com/mapfiles/marker.png",
          map: map,
        });
        marker.id = id;
        markerList.push(marker);
        let markerTitle = name;
        ((marker, markerTitle) => {
          //@ts-ignore
          google.maps.event.addListener(
            marker,
            "click",

            // this.markerClicked(marker)

            () => {
              markerList.forEach((marker1) => {
                // let label = marker1.getLabel();
                //label.color = 'black';
                //marker1.setLabel(label);
                marker1.setIcon("https://www.google.com/mapfiles/marker.png");
              });
              //@ts-ignore
              marker.setIcon(
                "https://www.google.com/mapfiles/marker_green.png"
              );
              markerClicked(marker);
            }
          );
        })(marker, markerTitle);
      }
    }
  };
  //@ts-ignore
  const markerClicked = (marker: MarkerObject) => {
    setState({ ...state, currentMarker: marker });
  };

  // const initFirebase = async (database: firebase.database.Database) => {
  //   if (!window.google) {
  //     let googleMapPromise = getGoogleMaps();
  //     await Promise.all([googleMapPromise]);
  //   }
  //   for (const key in onlineBuildingGuards) {
  //     if (onlineBuildingGuards.hasOwnProperty(key)) {
  //       const onlineBuildingGuard = onlineBuildingGuards[key];
  //       //@ts-ignore
  //       if (!onlineBuildingGuardIds.includes(key)) {
  //         //user logged in
  //         let locationListener = database.ref(
  //           "buildings/" + currentBuilding!.Id + "/lastLocations/" + key
  //         );
  //         locationListener.on("value", (snapshot: any) => {
  //           const location = snapshot.val();
  //           if (location !== null) {
  //             checkIfUserHasMarker(
  //               onlineBuildingGuard.name,
  //               location,
  //               onlineBuildingGuard.buildingGuardId
  //             );
  //           } else {
  //             //user changed roles or logged out
  //           }
  //         });
  //         const locationListenerObject: LocationListenerObject = {
  //           id: key,
  //           listener: locationListener,
  //         };
  //         const firebaseLocationListenerObjects: LocationListenerObject[] =
  //           state.firebaseLocationListenerObjects;
  //         firebaseLocationListenerObjects.push(locationListenerObject);
  //       }
  //     }
  //   }
  // };
  const styles = {
    container: {
      height: "70vh",
      width: "100%",
      //display: 'flex',
      //flexDirection: 'column',
    },
  };
  return (
    <StandardContainer>
      {/* <Button onClick={setFloor}>change</Button> */}
      <div id="map" style={styles.container} />;
    </StandardContainer>
  );
}
